module.exports = {
  sm: '640px',
  md: '768px',
  lg: '1025px',
  xl: '1280px',
}
